<template>
    <span>
        <router-link :to="{name:'DayTemplatesHome'}" tag="a">
            <i class="fas fa-arrow-left"></i>
        </router-link>
        <span class="title-separator">|</span>
        <span>
            <span v-if="isLoadingDayTemplate">...</span>
            <span v-else-if="currentDayTemplate != null">
                <!--{{ Translations.sections.dayTemplates.sectionTitle }}
            <span class="title-separator">-</span>-->
                <span v-if="isLoadingDayTemplate">Loading DayTemplate ...</span>
                <span v-else>{{ currentDayTemplate.name }}</span>
            </span>
        </span>
    </span>
</template>
<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'

    import Translations from '@/store/translations';


    export default {
        name: "DayTemplateHeader",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
            ...mapState(
                ["currentDayTemplate", "isLoadingDayTemplate"]),
        },
        data() {
            return {}
        }
    }

</script>

<style scoped>
</style>
